export const KEY_CODES = {
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39,
  ESCAPE: 27,
  TAB: 9,
  SPACE: 32,
  ENTER: 13,
};
